<action-box *ngIf="visible" textLeft="{{actionBoxTitle}}" [showHeader]="showHeader">
  
    <decoration-codes-builder [valuesModel]="valuesModel" [showInlineTitle]="false" ></decoration-codes-builder>

</action-box>
